const ITEMS = ["Upcoming shows", "JayPanduh collective", "JayPanduh Exclusive members get $5 off every show", "Bookings open", "Merch drops soon"];

export const Marquee = ({ inverted = false }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y py-5 ${inverted ? "bg-[#56ED4A] text-black border-black" : "border-white/10"}`}>
      <div className="flex w-max animate-marquee">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="font-display uppercase text-4xl md:text-6xl px-6 flex items-center gap-6 whitespace-nowrap">
                {t}<span className={inverted ? "text-[#0A0A0C]" : "text-[#56ED4A]"}>✶</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
